module.exports = __webpack_public_path__ + "img/status-successful.c902e8bf.svg";